import React from 'react';

import { Link } from "react-router-dom";

const SingleMenu = ({menu, link, icon}) => {
    return ( 
        <li className="nav-item">
                <Link className="nav-link" to={link}>
                    <i className="fas fa-fw fa-cog">{icon}</i>
                    <span>{menu}</span>
                </Link>                        
            </li>
     );
}
 
export default SingleMenu;